import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ClipboardModule, ClipboardService } from 'ngx-clipboard';

import { IconSpriteModule } from '@personal-area/icon-sprite';

@Component({
  selector: 'tooltip-copy-link',
  templateUrl: 'tooltip-copy-link.component.html',
  styleUrls: ['tooltip-copy-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatTooltipModule,
    MatButtonModule,
    ClipboardModule,
    IconSpriteModule,
  ],
})
export class TooltipCopyLinkComponent {
  @ViewChild('container') container!: ElementRef<HTMLElement>;
  @Input() copyLabel: string = '';
  @Input() text: string = '';
  @Input() copyTooltipLabel: string = '';
  @Input() copiedTooltipLabel: string = '';
  @Input() copyLink: boolean = false;
  @Input() type: 'button' | 'link' | 'icon' | 'button-border' = 'button';
  @Input() iconBlueBorderStyle = false;
  @Output() copied = new EventEmitter<void>();

  private _clipboardService = inject(ClipboardService);

  public copy(): void {
    this._clipboardService.copyFromContent(
      this.text,
      this.container.nativeElement,
    );
    this.copied.emit();
  }
}
